"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isContentClassificationTermsProperty = exports.contentClassificationTermsPropertyDefinition = void 0;
exports.contentClassificationTermsPropertyDefinition = {
    view: {
        label: 'Custom tracking tags',
        hint: 'Group assets together for tracking purposes.',
    },
    constraints: [],
    multiple: true,
    type: 'text',
    name: 'content-classification-terms',
};
const isContentClassificationTermsProperty = (prop) => {
    return prop.name === exports.contentClassificationTermsPropertyDefinition.name;
};
exports.isContentClassificationTermsProperty = isContentClassificationTermsProperty;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiY29udGVudC1jbGFzc2lmaWNhdGlvbi10ZXJtcy5wcm9wZXJ0eS5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9wcm9wZXJ0aWVzL2NvbnRlbnQtY2xhc3NpZmljYXRpb24tdGVybXMucHJvcGVydHkudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7O0FBRWEsUUFBQSw0Q0FBNEMsR0FBRztJQUMxRCxJQUFJLEVBQUU7UUFDSixLQUFLLEVBQUUsc0JBQXNCO1FBQzdCLElBQUksRUFBRSw4Q0FBOEM7S0FDckQ7SUFDRCxXQUFXLEVBQUUsRUFBRTtJQUNmLFFBQVEsRUFBRSxJQUFJO0lBQ2QsSUFBSSxFQUFFLE1BQU07SUFDWixJQUFJLEVBQUUsOEJBQThCO0NBQ0wsQ0FBQTtBQUkxQixNQUFNLG9DQUFvQyxHQUFHLENBQUMsSUFBa0IsRUFBOEMsRUFBRTtJQUNySCxPQUFPLElBQUksQ0FBQyxJQUFJLEtBQUssb0RBQTRDLENBQUMsSUFBSSxDQUFBO0FBQ3hFLENBQUMsQ0FBQTtBQUZZLFFBQUEsb0NBQW9DLHdDQUVoRCJ9